import * as React from "react"

const RedSquare = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <rect
      x={3}
      y={4}
      width={16}
      height={12}
      fill="#E10003"
      rx={1}
    />
  </svg>
)

export default RedSquare